export const APIPaths = {
  endPoint: "https://farminthecity.my/",
  //Public
  getMap: "wp-json/public/map/v1/get_map",
  //Admin
};
